;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import Cookies from "js-cookie";

async function asyncDeleteCookie(key: string, options?: Cookies.CookieAttributes) {
  Cookies.remove(key, options)

  return new Promise<void>((resolve) => {
    const intervalId = setInterval(() => {
      if(!Cookies.get(key)) {
        clearInterval(intervalId)
        resolve()
      }
    }, 100)
  })
}

export { asyncDeleteCookie }
